<template>
  <Popup :closable="errorPopup.closable" transitionname="fastfade" :drop="true"  :modelValue="errorPopupShow" @update:modelValue="$store.commit('setErrorPopupShow', $event)">
    <h3 class="pfpopup__title">{{ errorPopup.title }}</h3>
    <p class="pfpopup__text pfpopup__text_centered" v-if="errorPopup.text" v-html="errorPopup.text"></p>
    <Btn @click="errorPopup.action" class="pfpopup__btn pfpopup__btn_closer">{{ errorPopup.button }}</Btn>
  </Popup>
</template>

<script>
import { mapState } from 'vuex';
import Btn from './Btn.vue';
import Popup from './Popup.vue';
export default {
  components: { Popup, Btn },
  computed: {
    ...mapState(['errorPopup', 'errorPopupShow'])
  }
}
</script>

<style lang="sass" scoped>

</style>